import type { FC } from "react";

import omit from "lodash/omit";
import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { SimpleDropdownItem } from "@similarweb/ui-components";

import type { PropsOf } from "app/helpers/types/react";

const DropdownItemUnselectable: FC<PropsOf<typeof SimpleDropdownItem>> = (props) => (
    <SimpleDropdownItem {...omit(props, "selected")} />
);

export const DropdownItem = styled(DropdownItemUnselectable)`
    &.DropdownItemStep {
        text-indent: 0;
        padding: 14px 16px;
        color: #2a3e52;
        font-size: 14px;
        line-height: 34px;
        height: 34px;
        font-style: normal;
        font-weight: normal;
        background: ${(p) => (p.selected ? colorsPalettes.bluegrey[100] : colorsPalettes.carbon[0])};
    }

    &:hover {
        background: #f4f5f6;
    }
    border-top: 1px solid ${colorsPalettes.carbon[50]};
`;

export const DropdownItemDate = styled.span`
    color: #7f8b97;
`;

export const BottomSection = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    padding: 3px;
`;

export const GranularitySwitchContainer = styled.div`
    margin: 8px;
`;

export const LockedItemPillStyled = styled.span`
    letter-spacing: 0.6px;
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
`;
